var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqualAiAlgorithmic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4961_57332",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 34,
    width: 50,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 34.5H15V45.5H65V34.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4961_57332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0077 38.5762H21.6527V40.2781H18.0077V38.5762Z",
    fill: "#332170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 44.4984H21.6527V42.7962H17.1193H17.1187V36.3538H17.1193H21.6527V34.6516H15V44.4984Z",
    fill: "#332170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.993 34.5C25.9113 34.5 23.5553 36.7785 23.5553 39.5921C23.5553 42.4057 25.9113 44.6842 28.993 44.6842C29.8807 44.689 30.7561 44.4861 31.5416 44.0934L33.038 45.5L34.3123 44.2902L32.9936 43.0525C33.8826 42.1522 34.416 40.9285 34.416 39.5921C34.416 36.7785 32.06 34.5 28.993 34.5ZM31.841 41.0582C31.7477 41.2647 31.6324 41.4617 31.497 41.6459L31.493 41.6418C31.1086 42.1582 30.583 42.5529 29.977 42.7595C29.9666 42.763 29.9563 42.7671 29.946 42.7703L29.9406 42.7722C29.6366 42.8756 29.3159 42.9276 28.993 42.926C27.1556 42.926 25.8223 41.463 25.8223 39.5921C25.8223 37.7212 27.1556 36.2582 28.993 36.2582C30.4036 36.2582 31.5206 37.1348 31.9536 38.3984C32.2688 39.267 32.2286 40.2164 31.841 41.0582Z",
    fill: "#332170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.149 39.592C32.1527 40.0955 32.0479 40.5945 31.8409 41.0581C32.2286 40.2163 32.2688 39.2669 31.9536 38.3983C32.0845 38.784 32.1504 39.1868 32.149 39.592Z",
    fill: "#332170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5174 40.1237C42.5174 42.0085 41.7174 42.9085 40.4576 42.9085C39.198 42.9085 38.4 42.0085 38.4 40.1237V34.6519H36.2793V39.8563C36.2793 42.9509 37.524 44.6664 40.4279 44.6664C43.3914 44.6664 44.6359 42.9503 44.6359 39.8563V34.6519H42.5174V40.1237Z",
    fill: "#332170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9466 34.6519L49.7269 35.1626L53.1175 44.4984H55.5622L51.6655 34.6519H49.9466Z",
    fill: "#12E5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.384 41.0238L50.167 38.9681L49.2166 36.3481L45.7094 44.4985H48.065L48.7617 42.6697H51.5097L50.9127 41.0238H49.384Z",
    fill: "#12E5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3711 44.4984H59.4836V34.6519H57.3646L57.3711 44.4984Z",
    fill: "#12E5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3703 42.7963H65V44.4982H60.3703V42.7963Z",
    fill: "#332170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0071 34.9213V34.652H61.8938V34.9213H62.2828V36.2096H62.618V34.9213H63.0071Z",
    fill: "#332170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7279 35.0726V36.2096H65.0631V34.652H64.5779L64.1209 35.7379L63.6803 34.652H63.1857V36.2096H63.5209V35.0681L63.999 36.2096H64.2381L64.7279 35.0726Z",
    fill: "#332170"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualAiAlgorithmic);
export default __webpack_public_path__ + "static/media/equal-ai-algorithmic.43b377218d2fc739b9f994b97d1379c3.svg";
export { ForwardRef as ReactComponent };